import { MergedStation } from './../model/merged-station.interface';
import { BehaviorSubject } from 'rxjs';
import { StationCardDialogComponent } from './station-card-dialog/station-card-dialog.component';
import { Component, OnInit, Output, EventEmitter, Input, AfterContentInit, ContentChild } from '@angular/core';
import { IStationCardField, StationCardField, Stream } from './station-card.model';
import { StationCardHoverComponent } from './station-card-hover.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-station-card',
    templateUrl: './station-card.component.html',
    styleUrls: ['./station-card.component.scss', './station-card-dark.component.scss'],
    exportAs: 'appStationCard'
})
export class StationCardComponent {


    @ContentChild('app-station-card-hover', { static: true })
    hover: StationCardHoverComponent;

    @Input()
    public stationItem: MergedStation;

    @Output()
    public favoriteChange: EventEmitter<IStationCardField> = new EventEmitter<IStationCardField>();

    @Output()
    public playLive: EventEmitter<IStationCardField> = new EventEmitter<IStationCardField>();

    @Output()
    public gotoTranscriptions: EventEmitter<IStationCardField> = new EventEmitter<IStationCardField>();

    cloneDeep = require('lodash.clonedeep');

    constructor(private dialog: MatDialog) { }

    isPlaying(id) {
        // TODO: Need to write a service to get if current station is playing ??
        return false;
    }

    chooseDialogPlay(station: IStationCardField) {
        if (station.id.length > 1) {
            const dialogRef = this.dialog.open(StationCardDialogComponent, {
                disableClose: false,
                data: station
            });


            dialogRef.afterClosed().subscribe((result: number) => {
                if (result) {
                    this.play(result);
                }
            });
        } else {
            this.play(station.id[0]);
        }
    }

    chooseDialogTranscript(station: IStationCardField) {
        if (station.id.length > 1) {
            const dialogRef = this.dialog.open(StationCardDialogComponent, {
                disableClose: false,
                data: station
            });


            dialogRef.afterClosed().subscribe((result: number) => {
                if (result) {
                    this.showTranscriptions(result);
                }
            });
        } else {
            this.showTranscriptions(station.id[0]);
        }
    }

    play(id) {
        const paramItem = this.cloneDeep(this.stationItem);
        paramItem.id = id;
        this.playLive.emit(paramItem);
    }

    showTranscriptions(id) {
        const paramItem = this.cloneDeep(this.stationItem);
        paramItem.id = id;
        this.gotoTranscriptions.emit(paramItem);
    }

    public onFavoriteChange($event): void {
        this.stationItem.favorite = $event;
        this.favoriteChange.emit(this.stationItem);
    }

    setPlaceholderImage() {
        this.stationItem.logoUrl = 'assets/images/no-image-placeholder.jpg';
    }

}
